import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "facility-explorer-page" }
const _hoisted_2 = { class: "fx-shell" }
const _hoisted_3 = { class: "console-page-head" }
const _hoisted_4 = { class: "console-page-copy" }
const _hoisted_5 = { class: "console-title" }
const _hoisted_6 = { class: "console-head-side" }
const _hoisted_7 = { class: "console-count" }
const _hoisted_8 = { class: "fx-filters" }
const _hoisted_9 = { class: "fx-filter-row" }
const _hoisted_10 = { class: "fx-field" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "fx-field" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "fx-field" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "fx-field" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "fx-field fx-field--grow" }
const _hoisted_20 = { class: "fx-search-wrap" }
const _hoisted_21 = { class: "fx-actions" }
const _hoisted_22 = { class: "fx-biz-row" }
const _hoisted_23 = { class: "fx-biz-chips" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "fx-main" }
const _hoisted_26 = { class: "fx-table-wrap" }
const _hoisted_27 = { class: "row-num" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "facility-name" }
const _hoisted_30 = {
  key: 0,
  class: "facility-region"
}
const _hoisted_31 = {
  key: 0,
  class: "biz-chips"
}
const _hoisted_32 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_33 = { class: "facility-num-cell" }
const _hoisted_34 = { class: "sales-info-text" }
const _hoisted_35 = {
  key: 0,
  class: "sales-info-text"
}
const _hoisted_36 = { class: "sales-info-text" }
const _hoisted_37 = {
  key: 0,
  class: "sales-info-text"
}
const _hoisted_38 = {
  key: 2,
  class: "text-grey"
}
const _hoisted_39 = {
  key: 0,
  class: "sales-log-count"
}
const _hoisted_40 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_41 = { class: "empty-message" }
const _hoisted_42 = { class: "table-footer" }
const _hoisted_43 = { class: "footer-left" }
const _hoisted_44 = { class: "total-count" }
const _hoisted_45 = { class: "footer-center" }
const _hoisted_46 = { class: "footer-right" }

import { reactive, ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { crawlApi, salesApi, orgApi } from '@/services/api';
import CrawlExcelDownloadDialog from '@/components/crawl/CrawlExcelDownloadDialog.vue';
import WageSimpleDiagnosisDialog from '@/components/facility/WageSimpleDiagnosisDialog.vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CrawlDataExplorerPage',
  setup(__props) {

const store = useStore();
const route = useRoute();
const currentUser = computed(() => store.getters.currentUser);

const loading = ref(false);
const excelDialogOpen = ref(false);
const wageDiagOpen = ref(false);
const wageDiagTarget = ref<any>(null);
const rows = ref<any[]>([]);
const sidoOptions = ref<any[]>([]);
const sigunguOptions = ref<any[]>([]);

const visibleOrgCodes = ref<Set<string>>(new Set());
const bizGubunMap = ref<any[]>([]);

const bizGubunSelectOptions = computed(() => {
  return bizGubunMap.value.map((m: any) => ({
    label: m.cbm_short,
    value: m.cbm_short,
    color: m.cbm_color
  }));
});

const toggleBizGubun = (value: string) => {
  const idx = filters.bizGubuns.indexOf(value);
  if (idx >= 0) {
    filters.bizGubuns.splice(idx, 1);
  } else {
    filters.bizGubuns.push(value);
  }
};

const bizTableMark = (short: string) => {
  const marks: Record<string, string> = {
    요양시설: '요양',
    주야간보호: '주야',
    방문요양: '방문',
    방문목욕: '목욕',
    방문간호: '간호',
    공동생활가정: '공동',
    복지용구: '복지',
    치매전담1실: '치1',
    치매전담2실: '치2',
    주야간치매전담1실: '주1',
  };
  return marks[short] || short.slice(0, 2);
};

const parseBizGubun = (raw: string) => {
  if (!raw) return [];
  const names = raw.split(',').map(s => s.trim());
  const seen = new Set<string>();
  const result: { short: string; mark: string; color: string }[] = [];

  for (const name of names) {
    const found = bizGubunMap.value.find((m: any) => {
      return m.cbm_raw.split(',').map((s: string) => s.trim()).includes(name);
    });
    const short = found ? found.cbm_short : name;
    const color = found ? found.cbm_color : '#90a4ae';
    if (!seen.has(short)) {
      seen.add(short);
      result.push({ short, mark: bizTableMark(short), color });
    }
  }
  return result;
};

const getBizShortText = (raw: string) => {
  const chips = parseBizGubun(raw);
  return chips.map((c) => c.short).join(', ');
};

const openWageDiag = (item: any) => {
  wageDiagTarget.value = {
    ccNumber: item.cc_number,
    name: item.cc_name,
    biz: getBizShortText(item.cc_biz_gubun),
    wageDiagCount: item.wage_diag_count || 0,
    wageDiagWdate: item.wage_diag_wdate,
    wageDiagUId: item.wage_diag_u_id,
  };
  wageDiagOpen.value = true;
};

const syncWageDiagTarget = (ccNumber: string) => {
  const row = rows.value.find((r: any) => r.cc_number === ccNumber);
  if (row && wageDiagTarget.value?.ccNumber === ccNumber) {
    wageDiagTarget.value = {
      ...wageDiagTarget.value,
      wageDiagCount: row.wage_diag_count || 0,
      wageDiagWdate: row.wage_diag_wdate,
      wageDiagUId: row.wage_diag_u_id,
    };
  }
};

const onWageDiagSaved = async (ccNumber: string) => {
  await fetchList(pagination.page);
  syncWageDiagTarget(ccNumber);
};

const onWageDiagDeleted = async (ccNumber: string) => {
  await fetchList(pagination.page);
  syncWageDiagTarget(ccNumber);
};

const filters = reactive({
  sidoCode: null as string | null,
  sigunguCode: null as string | null,
  bizGubuns: [] as string[],
  minCapacity: null as number | null,
  minCurrent: null as number | null,
  search: '',
  salesFilter: null as string | null,
  wageDiagFilter: '' as string,
});

const salesFilterOptions = [
  { label: '영업중', value: 'active' },
  { label: '회원가입성공', value: 'completed' },
  { label: '미영업', value: 'none' }
];

const wageDiagFilterOptions = [
  { label: '전체', value: '' },
  { label: '임금진단 완료', value: 'done' },
  { label: '미진단', value: 'none' },
];

const excelSeedFilters = computed(() => {
  const hintParts: string[] = [];

  if (filters.sidoCode) {
    const sido = sidoOptions.value.find((s: any) => s.sido_code === filters.sidoCode);
    if (sido) hintParts.push(sido.sido_name);
  }
  if (filters.sigunguCode) {
    const sigungu = sigunguOptions.value.find((s: any) => s.sigungu_code === filters.sigunguCode);
    if (sigungu) hintParts.push(sigungu.sigungu_name);
  }
  if (filters.bizGubuns.length > 0) {
    hintParts.push(filters.bizGubuns.join(', '));
  }
  if (filters.salesFilter) {
    const sales = salesFilterOptions.find(o => o.value === filters.salesFilter);
    if (sales) hintParts.push(sales.label);
  }
  if (filters.wageDiagFilter) {
    const wage = wageDiagFilterOptions.find(o => o.value === filters.wageDiagFilter);
    if (wage && wage.value) hintParts.push(wage.label);
  }
  const searchText = filters.search?.trim();
  if (searchText) {
    hintParts.push(`검색:${searchText}`);
  }
  if (filters.minCapacity != null) {
    hintParts.push(`정원≥${filters.minCapacity}`);
  }
  if (filters.minCurrent != null) {
    hintParts.push(`현원≥${filters.minCurrent}`);
  }

  return {
    sidoCodes: filters.sidoCode ? [filters.sidoCode] : [],
    sigunguCode: filters.sigunguCode,
    bizGubuns: filters.bizGubuns.length ? [...filters.bizGubuns] : [],
    search: searchText || undefined,
    salesFilter: filters.salesFilter || undefined,
    total_capacity_min: filters.minCapacity ?? undefined,
    total_current_min: filters.minCurrent ?? undefined,
    filterHint: hintParts.length ? hintParts.join(' · ') : undefined,
  };
});

const pageTitleOverride = ref('');

const applyRouteQueryFilters = async () => {
  const q = route.query;
  const qSido = typeof q.sido === 'string' ? q.sido : null;
  const qSigungu = typeof q.sigungu === 'string' ? q.sigungu : null;
  const qBiz = typeof q.bizGubun === 'string' ? q.bizGubun : null;
  const qLabel = typeof q.label === 'string' ? q.label : null;
  const qSearch = typeof q.search === 'string' ? q.search.trim() : '';

  if (qLabel) pageTitleOverride.value = qLabel;
  if (qSearch) filters.search = qSearch;

  if (!qSido && !qSigungu && !qBiz) return;

  if (qSido) {
    filters.sidoCode = qSido;
    await onSidoChange();
  }
  if (qSigungu) {
    filters.sigunguCode = qSigungu;
  }
  if (qBiz) {
    filters.bizGubuns = [qBiz];
  }
};

const pagination = reactive({
  page: 1,
  limit: 100,
  total: 0,
  totalPages: 1
});

const regionText = (item: { sido_name?: string; sigungu_name?: string }) =>
  [item.sido_name, item.sigungu_name].filter(Boolean).join(' ');

const tableHeaders = [
  { title: 'No', key: 'index', sortable: false, align: 'center' as const },
  { title: '시설명', key: 'cc_name', sortable: true },
  { title: '제공서비스', key: 'cc_biz_gubun', sortable: false },
  { title: '정원/현원', key: 'capacity', sortable: false, align: 'end' as const },
  { title: '영업', key: 'sales_status', sortable: false },
  { title: '이력', key: 'sales_log_count', sortable: true, align: 'center' as const },
  { title: '임금진단', key: 'wage_diag', sortable: false, align: 'center' as const },
];

const canSeeSalesDetail = (salesOrgCode: string) => {
  if (!currentUser.value) return false;
  if (currentUser.value.roleLevel >= 60) return true;
  if (currentUser.value.roleLevel >= 60) {
    return visibleOrgCodes.value.has(salesOrgCode);
  }
  return false;
};

const collectDescendantCodes = (tree: any[], orgCode: string): string[] => {
  const codes: string[] = [];
  const findAndCollect = (nodes: any[], found: boolean) => {
    for (const node of nodes) {
      if (found || node.org_code === orgCode) {
        codes.push(node.org_code);
        if (node.children) {
          findAndCollect(node.children, true);
        }
        if (!found && node.org_code === orgCode) continue;
      }
      if (!found && node.children) {
        findAndCollect(node.children, false);
      }
    }
  };
  findAndCollect(tree, false);
  return codes;
};

const loadVisibleOrgCodes = async () => {
  if (!currentUser.value || currentUser.value.roleLevel < 60) return;
  if (currentUser.value.roleLevel >= 60) return;

  try {
    const res = await orgApi.getTree();
    const tree = res.data?.data || [];
    const myOrgCode = currentUser.value.orgCode;
    if (myOrgCode) {
      visibleOrgCodes.value = new Set(collectDescendantCodes(tree, myOrgCode));
    }
  } catch (error) {
    console.error('조직 트리 로드 오류:', error);
  }
};

let detailPopupWindow: Window | null = null;

const onSidoChange = async () => {
  filters.sigunguCode = null;
  if (!filters.sidoCode) {
    sigunguOptions.value = [];
    return;
  }
  try {
    const res = await crawlApi.getSigunguList(filters.sidoCode);
    sigunguOptions.value = res.data?.data || [];
  } catch (error: any) {
    if (error?.response?.status === 401) return;
    sigunguOptions.value = [];
  }
};

const fetchOptions = async () => {
  try {
    const [sidoRes, bizRes] = await Promise.all([
      crawlApi.getSidoList(),
      crawlApi.getBizGubunList()
    ]);
    sidoOptions.value = sidoRes.data?.data || [];
    bizGubunMap.value = bizRes.data?.data || [];
  } catch (error: any) {
    if (error?.response?.status === 401) return;
    console.error('시설검색 옵션 로드 오류:', error);
  }
};

const fetchList = async (page = pagination.page) => {
  loading.value = true;
  try {
    pagination.page = page;
    const res = await crawlApi.getList({
      sidoCode: filters.sidoCode,
      sigunguCode: filters.sigunguCode,
      bizGubuns: filters.bizGubuns.length ? filters.bizGubuns.join(',') : null,
      search: filters.search || undefined,
      minCapacity: filters.minCapacity,
      minCurrent: filters.minCurrent,
      salesFilter: filters.salesFilter,
      wageDiagFilter: filters.wageDiagFilter || null,
      page: pagination.page,
      limit: pagination.limit,
    });
    rows.value = res.data?.data || [];
    pagination.total = res.data?.pagination?.total || 0;
    pagination.totalPages = res.data?.pagination?.totalPages || 1;
  } catch (error: any) {
    // 401은 api 인터셉터가 로그인으로 보냄 — 오버레이만 막음
    if (error?.response?.status === 401) return;
    rows.value = [];
    pagination.total = 0;
    pagination.totalPages = 1;
    const message = error?.response?.data?.message || error?.message || '알 수 없는 오류';
    alert(`시설 목록 조회 실패: ${message}`);
    console.error('시설 목록 조회 오류:', error);
  } finally {
    loading.value = false;
  }
};

const resetFilters = async () => {
  filters.sidoCode = null;
  filters.sigunguCode = null;
  filters.bizGubuns = [];
  filters.minCapacity = null;
  filters.minCurrent = null;
  filters.search = '';
  filters.salesFilter = null;
  filters.wageDiagFilter = '';
  sigunguOptions.value = [];
  await fetchList(1);
};

const openDetail = (ccNumber: string) => {
  const url = `/facility/detail/${ccNumber}`;
  const width = 1100;
  const height = 720;
  const left = 0;
  const top = 0;
  const features = `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes`;

  detailPopupWindow = window.open(url, 'facilityDetailPopup', features);

  if (detailPopupWindow) {
    detailPopupWindow.focus();
  }
};

const handlePopupMessage = async (event: MessageEvent) => {
  if (event.data?.type !== 'salesUpdated') return;
  const ccNumber = event.data.ccNumber;
  if (!ccNumber) return;

  try {
    const res = await salesApi.getSalesByFacility(ccNumber);
    const sales = res.data?.data?.sales || null;
    const logs = res.data?.data?.logs || [];

    const rowIndex = rows.value.findIndex((r: any) => r.cc_number === ccNumber);
    if (rowIndex !== -1) {
      if (sales) {
        rows.value[rowIndex].sales_idx = sales.sales_idx;
        rows.value[rowIndex].sales_status = sales.sales_status;
        rows.value[rowIndex].sales_u_idx = sales.u_idx;
        rows.value[rowIndex].sales_org_code = sales.org_code;
        rows.value[rowIndex].sales_org_name = sales.sales_org_name;
        rows.value[rowIndex].sales_user_name = sales.sales_user_name;
      } else {
        rows.value[rowIndex].sales_idx = null;
        rows.value[rowIndex].sales_status = null;
        rows.value[rowIndex].sales_u_idx = null;
        rows.value[rowIndex].sales_org_code = null;
        rows.value[rowIndex].sales_org_name = null;
        rows.value[rowIndex].sales_user_name = null;
      }
      rows.value[rowIndex].sales_log_count = logs.length;
    }
  } catch (error) {
    console.error('영업 정보 동기화 오류:', error);
  }
};

onMounted(async () => {
  window.addEventListener('message', handlePopupMessage);
  try {
    await Promise.all([
      fetchOptions(),
      loadVisibleOrgCodes()
    ]);
    await applyRouteQueryFilters();
    await fetchList(1);
  } catch (error: any) {
    if (error?.response?.status === 401) return;
    console.error('시설검색 초기화 오류:', error);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handlePopupMessage);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(pageTitleOverride.value || '시설검색'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(pagination.total.toLocaleString()) + "건", 1),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "fx-excel-btn",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (excelDialogOpen.value = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-microsoft-excel", -1)
                ]))]),
                _: 1
              }),
              _cache[15] || (_cache[15] = _createTextVNode(" 엑셀로 내려받기 ", -1))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "fx-label" }, "시·도", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.sidoCode) = $event)),
              class: "fx-select",
              onChange: onSidoChange
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "전체", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidoOptions.value, (s) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: s.sido_code,
                  value: s.sido_code
                }, _toDisplayString(s.sido_name), 9, _hoisted_11))
              }), 128))
            ], 544), [
              [_vModelSelect, filters.sidoCode]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "fx-label" }, "시·군·구", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.sigunguCode) = $event)),
              class: "fx-select",
              disabled: !filters.sidoCode
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "전체", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sigunguOptions.value, (g) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: g.sigungu_code,
                  value: g.sigungu_code
                }, _toDisplayString(g.sigungu_name), 9, _hoisted_14))
              }), 128))
            ], 8, _hoisted_13), [
              [_vModelSelect, filters.sigunguCode]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "fx-label" }, "영업상태", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.salesFilter) = $event)),
              class: "fx-select"
            }, [
              _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "전체", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(salesFilterOptions, (opt) => {
                return _createElementVNode("option", {
                  key: opt.value,
                  value: opt.value
                }, _toDisplayString(opt.label), 9, _hoisted_16)
              }), 64))
            ], 512), [
              [_vModelSelect, filters.salesFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "fx-label" }, "임금진단", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.wageDiagFilter) = $event)),
              class: "fx-select"
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wageDiagFilterOptions, (opt) => {
                return _createElementVNode("option", {
                  key: opt.value,
                  value: opt.value
                }, _toDisplayString(opt.label), 9, _hoisted_18)
              }), 64))
            ], 512), [
              [_vModelSelect, filters.wageDiagFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "fx-label" }, "시설명 검색", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_v_icon, {
                size: "16",
                class: "fx-search-icon"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("mdi-magnify", -1)
                ]))]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.search) = $event)),
                type: "text",
                class: "fx-input",
                placeholder: "시설명 / 주소 / 번호",
                onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (fetchList(1)), ["enter"]))
              }, null, 544), [
                [_vModelText, filters.search]
              ]),
              (filters.search)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "fx-search-clear",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (filters.search = ''))
                  }, [
                    _createVNode(_component_v_icon, { size: "12" }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-search",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (fetchList(1)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("mdi-magnify", -1)
                  ]))]),
                  _: 1
                }),
                _cache[27] || (_cache[27] = _createTextVNode(" 검색 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-reset",
              onClick: resetFilters
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode(" 초기화 ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "fx-label" }, "제공서비스", -1)),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizGubunSelectOptions.value, (opt) => {
              return (_openBlock(), _createElementBlock("button", {
                key: opt.value,
                type: "button",
                class: _normalizeClass(["fx-biz-chip", { 'fx-biz-chip--selected': filters.bizGubuns.includes(opt.value) }]),
                style: _normalizeStyle({ '--chip-color': opt.color }),
                onClick: ($event: any) => (toggleBizGubun(opt.value))
              }, _toDisplayString(opt.label), 15, _hoisted_24))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(LoadingOverlay, {
            show: loading.value,
            text: "불러오는 중..."
          }, null, 8, ["show"]),
          _createVNode(_component_v_data_table, {
            class: "facility-explorer-data-table",
            headers: tableHeaders,
            items: rows.value,
            loading: loading.value,
            "items-per-page": pagination.limit,
            "fixed-header": "",
            hover: ""
          }, {
            "item.index": _withCtx(({ index }) => [
              _createElementVNode("span", _hoisted_27, _toDisplayString((pagination.page - 1) * pagination.limit + index + 1), 1)
            ]),
            "item.cc_name": _withCtx(({ item }) => [
              _createElementVNode("button", {
                type: "button",
                class: "facility-name-link",
                onClick: _withModifiers(($event: any) => (openDetail(item.cc_number)), ["stop"])
              }, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(item.cc_name), 1),
                (regionText(item))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(regionText(item)), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_28)
            ]),
            "item.cc_biz_gubun": _withCtx(({ item }) => [
              (item.cc_biz_gubun)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseBizGubun(item.cc_biz_gubun), (chip, ci) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: ci,
                        color: chip.color,
                        size: "x-small",
                        label: "",
                        variant: "flat",
                        class: "biz-chip",
                        title: chip.short
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(chip.mark), 1)
                        ]),
                        _: 2
                      }, 1032, ["color", "title"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
            ]),
            "item.capacity": _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_33, _toDisplayString(item.total_capacity || 0) + " / " + _toDisplayString(item.total_current || 0), 1)
            ]),
            "item.sales_status": _withCtx(({ item }) => [
              (item.sales_idx && item.sales_status === '영업중')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      variant: "flat",
                      color: "#1565c0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "10",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode("mdi-briefcase-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[31] || (_cache[31] = _createTextVNode(" 영업중 ", -1))
                      ]),
                      _: 1
                    }),
                    (canSeeSalesDetail(item.sales_org_code))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(item.sales_org_name), 1),
                          (item.sales_user_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, "· " + _toDisplayString(item.sales_user_name), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (item.sales_idx && item.sales_status === '회원가입')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        variant: "flat",
                        color: "#2e7d32"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "10",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                              _createTextVNode("mdi-check-circle-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[33] || (_cache[33] = _createTextVNode(" 회원가입성공 ", -1))
                        ]),
                        _: 1
                      }),
                      (canSeeSalesDetail(item.sales_org_code))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(item.sales_org_name), 1),
                            (item.sales_user_name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, "· " + _toDisplayString(item.sales_user_name), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_38, "-"))
            ]),
            "item.sales_log_count": _withCtx(({ item }) => [
              (item.sales_log_count > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.sales_log_count) + "건", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_40, "-"))
            ]),
            "item.wage_diag": _withCtx(({ item }) => [
              _createVNode(_component_v_btn, {
                variant: "flat",
                class: _normalizeClass([item.wage_diag_count > 0 ? 'wage-diag-cell-btn--done' : 'wage-diag-cell-btn--pending', "wage-diag-cell-btn"]),
                onClick: _withModifiers(($event: any) => (openWageDiag(item)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "12",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.wage_diag_count > 0 ? 'mdi-check-circle' : 'mdi-file-chart'), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createTextVNode(" " + _toDisplayString(item.wage_diag_count > 0 ? '완료' : '진단'), 1)
                ]),
                _: 2
              }, 1032, ["class", "onClick"])
            ]),
            "no-data": _withCtx(() => [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "grey-lighten-1"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("mdi-database-off-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[35] || (_cache[35] = _createElementVNode("p", null, "검색 결과가 없습니다", -1))
              ])
            ]),
            bottom: _withCtx(() => [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, [
                    _cache[36] || (_cache[36] = _createTextVNode("총 ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(pagination.total.toLocaleString()), 1),
                    _cache[37] || (_cache[37] = _createTextVNode("건", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  (pagination.totalPages > 1)
                    ? (_openBlock(), _createBlock(_component_v_pagination, {
                        key: 0,
                        modelValue: pagination.page,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((pagination.page) = $event)),
                          fetchList
                        ],
                        length: pagination.totalPages,
                        "total-visible": 7,
                        density: "compact"
                      }, null, 8, ["modelValue", "length"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_v_select, {
                    modelValue: pagination.limit,
                    "onUpdate:modelValue": [
                      _cache[10] || (_cache[10] = ($event: any) => ((pagination.limit) = $event)),
                      _cache[11] || (_cache[11] = ($event: any) => (fetchList(1)))
                    ],
                    items: [50, 100, 200, 300],
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    class: "page-size-select"
                  }, {
                    selection: _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.value) + "건씩", 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["items", "loading", "items-per-page"])
        ])
      ])
    ]),
    _createVNode(WageSimpleDiagnosisDialog, {
      modelValue: wageDiagOpen.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((wageDiagOpen).value = $event)),
      facility: wageDiagTarget.value,
      onSaved: onWageDiagSaved,
      onDeleted: onWageDiagDeleted
    }, null, 8, ["modelValue", "facility"]),
    _createVNode(CrawlExcelDownloadDialog, {
      modelValue: excelDialogOpen.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((excelDialogOpen).value = $event)),
      "initial-filters": excelSeedFilters.value
    }, null, 8, ["modelValue", "initial-filters"])
  ]))
}
}

})